<h1 class="title">PAIEMENT</h1>
<div class="payment-options">
  <div *ngFor="let img of iconsToDisplay$ | async">
    <img
      style="height: 48px; max-width: 85px; object-fit: scale-down;"
      [src]="img.iconUrl"
      alt="cheque bancaire"
    />
  </div>
</div>
<div class="payement-text" *ngIf="parameter$ | async as parameter">
  {{ parameter.paiementDescription }}
</div>
